import { Grid, Stack, Typography } from "@mui/material";
import React from "react";
import Floaticons from "../Floaticons";
import SapMMLearningCards from "./SapMMLearningCards";
import "./SapMMProcess.css";

function SapMMProcess() {
 return (
  <>
   <div id="SapMMContent">
    <div className="main-banner">
     <img src="images/SapMM/sapMM-banner.png" alt="Banner" className="banner-img" />
     <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" />
     <div className="announcemnt-box">
      <p>
       <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
       <marquee
        width="92%"
        direction="left"
        style={{ display: "inline-block", verticalAlign: "middle" }}
       >
        {" "}
        <b>Come Join Us</b> on an exhilarating learning Journey on ABC University
        Platform!!!
       </marquee>
      </p>
     </div>
     <Floaticons />
    </div>
    <div className="main-container">
     {/* section 1  */}
     <div className="about-container">
      <div className="about-wrap">
       <h2>About SAP MM</h2>
       <p>
        SAP MM (Material Management) Module is a SAP ERP component that helps
        organizations with material management, inventory management, and warehouse
        management in the supply chain process.
       </p>
      </div>
     </div>
     {/* section 2  */}
     <div id="sapMM-Objective">
      <div className="program-container">
       <div className="program-wrap">
        <h2>Program Objectives</h2>
        <p>
         SAP MM process covers the different processes to be followed in the project:
        </p>
        <Grid container sx={{ marginBottom: "1rem" }}>
         <Grid item xs={8}>
          <Stack spacing={1}>
           <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
             style={{ width: "16px", height: "16px" }}
             src="images/bulletWhite.png"
            ></img>
            <Typography>Master Data</Typography>
           </Stack>
           <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
             style={{ width: "16px", height: "16px" }}
             src="images/bulletWhite.png"
            ></img>
            <Typography>P2P Process</Typography>
           </Stack>
           <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
             style={{ width: "16px", height: "16px" }}
             src="images/bulletWhite.png"
            ></img>
            <Typography>Sub-Contracting</Typography>
           </Stack>

           <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
             style={{ width: "16px", height: "16px" }}
             src="images/bulletWhite.png"
            ></img>
            <Typography> Supply Chain Process</Typography>
           </Stack>
          </Stack>
         </Grid>
        </Grid>
        {/* <ul>
         <li>Master Data</li>
         <li>P2P Process</li>
         <li>Sub-Contracting</li>
         <li>Supply Chain Process</li>
        </ul> */}
       </div>
       {/* <div className="program-robot">
                            <img src="images/SRE/SRE-robot.png" alt="SRE-machine" className='SRE-robot' />
                        </div> */}
      </div>
     </div>
     {/* <LearningJourney /> */}
     {/* <div className='external-certification-container'>
                    <h5>External Certifications</h5>
                    <p>Complete your learning journey and earn accredited external certification in the area of your expertise which can help in advancing your career.</p>
                    <div className="ex-wrapper">
                        <div className='ex-box'>
                            <img src='images/SRE/certificates/SRE-DevOps.png' alt='certification-icon' />
                            <span>Lorem ipsum dolor sit amet consectetur elit.</span>
                        </div>
                        <div className='ex-box'>
                            <img src='images/SRE/certificates/SRE-Azure.png' alt='certification-icon' />
                            <span>Lorem ipsum dolor sit amet consectetur elit.</span>
                        </div>
                    </div>
                </div> */}
     <SapMMLearningCards />
     {/* <div className="features-container SRE">
                    <h5>Program Highlights</h5 >
                    <div className="features-wrap">
                        <div className="features-row">
                            <img src="images/SRE/feature-icon1.png" alt="feature-icon" className='feature-icon' />
                            <p>Self-paced Learning</p>
                        </div>
                        <div className="features-row">
                            <img src="images/SRE/feature-icon2.png" alt="feature-icon" className='feature-icon' />
                            <p>SME Connects</p>
                        </div>
                        <div className="features-row">
                            <img src="images/SRE/feature-icon3.png" alt="feature-icon" className='feature-icon' />
                            <p>Final Assessment</p>
                        </div>
                        <div className="features-row">
                            <img src="images/SRE/feature-icon4.png" alt="feature-icon" className='feature-icon' />
                            <p>Earn Completion Certificates, Flair, R&R</p>
                        </div>
                        <div className="features-row">
                            <img src="images/SRE/feature-icon6.png" alt="feature-icon" className='feature-icon' />
                            <p>End-to-End case studies</p>
                        </div>
                    </div>
                </div> */}
    </div>
   </div>
  </>
 );
}

export default SapMMProcess;
